import LayoutContainer from 'components/Common/LayoutContainer'
import Accordion from 'LuxKit/Accordion'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import useAirportTransferFAQs from '../hooks/useAirportTransferFAQs'

const Section = styled.section`
  padding-block: ${rem(60)};
`

const Content = styled.div`
  display: grid;
  gap: ${rem(48)};
`

const Answers = styled.div`
  display: grid;
  gap: ${rem(16)};
`

function CarsAirportTransferFAQs() {
  const intl = useIntl()
  const faqs = useAirportTransferFAQs()

  return (
    <Section>
      <LayoutContainer size="md">
        <Content>
          <Heading variant="heading3" align="center">
            {intl.formatMessage({
              id: 'NFW6mFiLDlCeXC2RpDnJ',
              defaultMessage: 'Frequently asked questions',
              description: 'Airport transfer FAQ section heading displayed below the transfer search area',
            })}
          </Heading>
          <div>
            {faqs.map((faq, index) => (
              <Accordion
                key={faq.id}
                heading={faq.question}
                size="large"
                hideDivider={index === faqs.length - 1}
              >
                {faq.answers && (
                  <Answers>
                    {faq.answers.map(answer => (
                      <BodyText key={answer} variant="medium">
                        {answer}
                      </BodyText>
                    ))}
                  </Answers>
                )}
              </Accordion>
            ))}
          </div>
        </Content>
      </LayoutContainer>
    </Section>
  )
}

export default CarsAirportTransferFAQs
